var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHomeSection1Icon1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 22,
    viewBox: "0 0 14 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4768 11.89L11.9918 20.416C12.0087 20.5164 11.9946 20.6196 11.9514 20.7118C11.9081 20.8039 11.8377 20.8807 11.7497 20.9318C11.6616 20.9829 11.56 21.0059 11.4586 20.9977C11.3571 20.9895 11.2605 20.9506 11.1818 20.886L7.60175 18.199C7.42893 18.0699 7.21898 18.0001 7.00325 18.0001C6.78752 18.0001 6.57758 18.0699 6.40475 18.199L2.81875 20.885C2.74007 20.9494 2.64361 20.9884 2.54225 20.9966C2.44088 21.0048 2.33942 20.9818 2.25141 20.9309C2.16341 20.8799 2.09303 20.8033 2.04967 20.7113C2.00631 20.6194 1.99204 20.5163 2.00875 20.416L3.52275 11.89",
    stroke: "#00AFEF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 13C10.3137 13 13 10.3137 13 7C13 3.68629 10.3137 1 7 1C3.68629 1 1 3.68629 1 7C1 10.3137 3.68629 13 7 13Z",
    stroke: "#00AFEF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeSection1Icon1);
export default __webpack_public_path__ + "static/media/home-section1-icon1.646dc68ba7ab8021d845a0030f677fcd.svg";
export { ForwardRef as ReactComponent };